import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { faAdd, faInfo, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataTableDynamic from '../../../../component/Table/DataTableDynamic';
import Tab from '../../../../component/Tabs/Tab';
import { confirmDelete } from '../../../../helpers/PromptUtils';
import { getToken } from '../../../../helpers/Jwt';

const Contact = () => {
    const navigate = useNavigate();
    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [activeType, setActiveType] = useState("customer");
    const tabHeader = [
        {
            "key": "customer",
            "label": "Pelanggan",
        },
        {
            "key": "supplier",
            "label": "Supplier"
        },
        {
            "key": "employee",
            "label": "Karyawan"
        },
        {
            "key": "others",
            "label": "Lainnya"
        }
    ];

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_CASH_BANK = "api/erpppsu/contact";

    // Fetch data from the API
    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_CASH_BANK}?type=${activeType}`).then((contacts) => {
            setData(contacts);
        });
    }, [activeType]);

    useEffect(() => {
        setKeys(data.length > 0 ? Object.keys(data[0]) : []);
    }, [data]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    const handleTabClick = (tab) => {
        setActiveType(tab);
    };

    const handleDelete = async (rowData) => {
        try {
            const confirmed = confirmDelete('Yakin Hapus Kontak ini?');
            if (confirmed) {
                axios({
                    method: 'POST',
                    url: process.env.REACT_APP_API_BASE_URL + 'api/erpppsu/contact/remove',
                    headers: {
                        Authorization: `Bearer ${getToken()}`,
                        "Content-Type": "application/json"
                    },
                    data: {
                        id: rowData.id.value
                    }
                }).then(function (response) {
                    window.location.reload();
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const actions = [{
        child: <button className='text-white text-xs rounded focus:ring bg-red-500 hover:bg-red-700 p-2 mx-1'>
            <FontAwesomeIcon icon={faTrash} color="white" /> Hapus
        </button>,
        callback: (rowData) => handleDelete(rowData)
    }];

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <div className='flex items-center justify-between px-5'>
                <h1>Kontak</h1>

                <div className='flex items-center'>
                    <button
                        className="text-white text-sm rounded focus:ring bg-blue-500 hover:bg-blue-700 p-2 my-2 ml-2"
                        type="button"
                        onClick={() => {
                            navigate('/activity-erpppsu/contact/new');
                        }}
                    >
                        <FontAwesomeIcon icon={faAdd} color="white" /> Tambah
                    </button>
                </div>
            </div>

            <div className="tabs">
                {tabHeader.map((tab) => (
                    <Tab name={tab.key} label={tab.label} activeTab={activeType} onClick={() => {
                        handleTabClick(tab.key)
                    }} />
                ))}
            </div>

            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                <DataTableDynamic
                    data={data}
                    elementClass="p-1"
                    columns={columns}
                    actions={actions}
                    enableCustom={false} />
            )}
        </div>
    )
}

export default Contact;